import Link from 'next/link'
import { Breadcrumb } from 'antd';

export default ({ bc }) => (
  <Breadcrumb style={{ margin: '8px' }}>
    {bc.map(
      ({ label, path }) => {
        if (path) {
          return <Breadcrumb.Item key="label"><Link href={path}><a>{label}</a></Link></Breadcrumb.Item>
        } else {
          return <Breadcrumb.Item key="label">{label}</Breadcrumb.Item>
        }
      }
    )}
  </Breadcrumb>
)